export const GET_PLACES = "GET_PLACES";
export const GET_LIST_PLACES = "GET_LIST_PLACES";
export const GET_PLACE = "GET_PLACE";
export const SET_PLACES = "SET_PLACES";
export const SET_LIST_PLACES = "SET_LIST_PLACES";
export const SET_PLACE = "SET_PLACE";
export const ADD_PLACE = "ADD_PLACE";
export const SET_NEW_PLACE = "SET_NEW_PLACE";
export const EDIT_PLACE = "EDIT_PLACE";
export const SET_EDIT_PLACE = "SET_EDIT_PLACE";
export const SET_DELETE_PLACE = "SET_DELETE_PLACE";
export const SET_DELETE_MULTI_PLACE = "SET_DELETE_MULTI_PLACE";
export const DELETE_PLACE = "DELETE_PLACE";
export const DELETE_MULTI_PLACE = "DELETE_MULTI_PLACE";
export const RESET_ITEMS_PLACE = "RESET_ITEMS_PLACE";
export const RESET_LIST_PLACES = "RESET_LIST_PLACES";
export const RESET_SELECTED_PLACE = "RESET_SELECTED_PLACE";
